import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router'
import { Observable, take } from 'rxjs'
import { map } from 'rxjs/operators'
import { AppRoutes } from '../../shared/constants/enums'
import { AuthService } from '../services/auth.service'

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    canActivateChild(
        childRoute: ActivatedRouteSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const token: string | null = childRoute.queryParamMap.get('token')
        if (token) {
            this.authService.login(token)
            return this.router.navigate(['/guarantee-orders'])
        }
        return this.authService.currentRepresentativeAccessToken.pipe(
            take(1),
            map((accessToken) => {
                if (!!accessToken) {
                    return true
                }
                return this.router.parseUrl(`/${AppRoutes.LOGGED_OUT}`)
            })
        )
    }
}
